import {
    Page,
    usePageNavigation
} from "./contexts/PageNavigationContextProvider";

import { AssessmentStatus } from "../../lib/dashboard/types/AssessmentStatus";
import { Box } from "@mui/material";
import { InspectionFailedChip } from "./chips/InspectionFailedChip";
import { InspectionMissingChip } from "./chips/InspectionMissingChip";
import { InspectionPassedChip } from "./chips/InspectionPassedChip";
import { ResolvedIssueChip } from "./chips/ResolvedIssueChip";
import { UnresolvedIssueChip } from "./chips/UnresolvedIssueChip";
import { useDashboardFilter } from "./DashboardFilterContext";
import { useIssueFilter } from "./contexts/IssueFilterContext";

type IssueCountTableCellContentProps = {
    resolved: number;
    unresolved: number;
    assessmentStatus: AssessmentStatus;
    date?: Date;
    locationId?: string;
};

export const IssueCountTableCellContent = ({ resolved, unresolved, date, locationId, assessmentStatus }: IssueCountTableCellContentProps) => {
    const pageNavigationContext = usePageNavigation();
    const { filter, updateFilter } = useIssueFilter();

    const handleClick = () => {
        const newFilter = { ...filter };
        if (date) {
            newFilter.date = {
                start: date,
                end: date
            };
        }
        if (locationId) {
            newFilter.locationIds = [locationId];
        }
        pageNavigationContext.navigateToPage(Page.Issues);
        updateFilter(newFilter);
    };
    const { filter: {
        showFailed,
        showMissing,
        showNumberOfResolvedIssues,
        showNumberOfUnresolvedIssues,
        showPassed
    } } = useDashboardFilter();

    const showInspectionPassed = assessmentStatus === AssessmentStatus.PASSED && showPassed;
    const showInspectionFailed = assessmentStatus === AssessmentStatus.FAILED && showFailed;
    const showInspectionMissing = assessmentStatus === AssessmentStatus.MISSING && showMissing;
    const showResolvedIssues = resolved > 0 && showNumberOfResolvedIssues;
    const showUnresolvedIssues = unresolved > 0 && showNumberOfUnresolvedIssues;

    // only allow click if there is something to show except for missing inspection
    const allowClick = showInspectionPassed || showInspectionFailed || showResolvedIssues || showUnresolvedIssues;

    return (
        <Box
            sx={{
                p: 0,
                textTransform: "none",
                display: "flex",
                gap: 1,
                flexWrap: "wrap",
                cursor: allowClick ? "pointer" : "default"
            }}
            onClick={allowClick ? () => handleClick() : undefined}
        >
            {showInspectionPassed && <InspectionPassedChip />}
            {showInspectionFailed && <InspectionFailedChip />}
            {showInspectionMissing && <InspectionMissingChip />}
            {showResolvedIssues && <ResolvedIssueChip label={resolved} />}
            {showUnresolvedIssues && <UnresolvedIssueChip label={unresolved} />}
        </Box>
    );
};